export const CREATE_CLASS_PAGE_TRACKINGS = {
  createContest: 'create_contest',
};
